<template>
  <div class="Home">
    <Topbar title="Bienvenue" />
    <section class="Section Section__offer">
      <div class="Section__header">
        <h2 class="Section__title">Nos offres cette semaine</h2>
        <router-link class="Button Button--next Section__action" :to="{name: 'Offers'}">Voir plus</router-link>
      </div>
      <ul class="ProductList products-offers-grid">
        <router-link :to="{ name: 'Product', params: { id: offer.id }}" :class="'container-card container-card-x' + offer.home_page_offers_grid_captain_vin" v-for="offer in offers" :key="offer.id">
          <ProductCard v-bind="offer" />
        </router-link>
      </ul>
    </section>
    <section class="Section--universe">
      <div class="container">
        <div class="Section__header">
          <h2 class="Section__title">Les univers Captain Vin</h2>
          <router-link v-if="showMoreUniverses" class="Button Button--next Section__action" :to="{name: 'Universes'}">Voir plus</router-link>
        </div>
        <ul class="UniverseList">
          <router-link v-for="universe in universes" :to="{name: 'Universe', params: { id: universe.id }}" :key="universe.id">
            <UniverseCard v-bind="universe" />
          </router-link>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import universeService from "../services/universe";
import productService from "../services/product";
import ProductCard from "../components/ProductCard";
import UniverseCard from "../components/UniverseCard";

export default {
  name: "Home",
  data() {
    return {
      offers: [],
      universes: [],
      showMoreUniverses: false
    };
  },
  computed: {
    ...mapGetters("auth", ["agent"])
  },
  created() {
    universeService.getAll().then(({ data: universes }) => {
      this.showMoreUniverses = universes.length > 3;
      this.universes = universes.sort(() => 0.5 - Math.random()).slice(0, 3);
    });

    productService.getHomeOffers().then(({ data: offers }) => {
      this.offers = offers.products;

      this.offers = this.offers.sort((a, b) => a.home_page_offers_position_captain_vin - b.home_page_offers_position_captain_vin);
    });
  },
  components: {
    ProductCard,
    UniverseCard
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';
@import '../assets/offers_cards';

.Section--universe {
  background-color: #fff;
}

@media (min-width: 900px) {
  .Section {
    &__offer {
      min-height: 50vh;
      padding: $global-margin;
      grid-gap: $global-margin;
      border: 0;
      border-radius: 10px;
    }
  }
}
</style>
